import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import Banner from './Banner';
import BufferOptionsItem from './BufferOptionsItem';

interface Props {
  banner?: ReactNode;
  leftChildren?: ReactNode;
  rightChildren?: ReactNode;
  // Default is true, but set to false for the instructions editor. Controls whether the editor is rendered
  // with position: absolute.
  fullScreen?: boolean;
}

export default function BufferOptions({
  banner,
  leftChildren,
  rightChildren,
  fullScreen = true,
}: Props): JSX.Element {
  return (
    <div
      className={classNames(
        'buffer-options',
        fullScreen && css(styles.fullScreen),
        !fullScreen && css(styles.embedded)
      )}
    >
      <div className="buffer-options-container">
        {leftChildren}
        <BufferOptionsItem className="buffer-options-item--bannerContainer">
          {banner && <Banner message={banner} />}
        </BufferOptionsItem>
        {rightChildren}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  fullScreen: {
    position: 'absolute',
  },
  embedded: {
    position: 'static',
  },
});
